import styles from "./Index.module.scss";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { MapViewBloc } from "../../MapViewBloc";

type tooltipProps = {
  bloc: MapViewBloc;
};

export function MapToolTip(props: tooltipProps) {
  const src = `${settings.S3CDN}${settings.viewAssetsPath}map_marker_stop.png`;
  const hasTips = props.bloc.tipError.value.key === "locationTip";

  return (
    <div className={styles.MapToolTip} style={{ background: hasTips ? "#000003D9" : "#ff4d4f" }}>
      <img src={src} alt="" />
      <div>
        <p>{hasTips ? "Imagica couldn’t determine your precise location." : props.bloc.tipError.value.value}</p>
        {hasTips && <span onClick={() => props.bloc.reloadLocation()}>How to turn on my location?</span>}
      </div>
    </div>
  );
}
